/* eslint-disable */
export default function SidewaysChart(opts, callback) {
    const VizHitTracking = require('./VizHitTracking')

    const svgBody = document.createElement('body')
    const viz = new VizHitTracking(svgBody)

    try {
        viz.render(opts.playData, opts, (svg) => {
            callback(svg)
        })
    } catch (err) {
        console.log(err)
        // return 1-pixel transparent svg
        callback('<svg width="1px" height="1px"></svg>')
    }
    /* new viz(opts, function (svg) {
        callback(svg);
    }); */
}
